"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StorageProxy_1 = require("./StorageProxy");
function createStorage(type) {
    var storageType = type + "Storage";
    if (typeof self !== 'object' || !(storageType in self)) {
        return null;
    }
    var storage = self[storageType];
    return {
        getAllKeys: function () { return StorageProxy_1.promiseResult(function () { return Object.keys(storage); }); },
        setItem: function (key, value) { return StorageProxy_1.promiseVoid(function () { return storage.setItem(key, value); }); },
        removeItem: function (key) { return StorageProxy_1.promiseVoid(function () { return storage.removeItem(key); }); },
        getItem: function (key) { return StorageProxy_1.promiseResult(function () { return storage.getItem(key); }); },
    };
}
exports.createStorage = createStorage;
//# sourceMappingURL=createStorage.js.map